import { Button, Dialog, DialogBody, DialogFooter, H5, Intent } from '@blueprintjs/core'
import React from 'react'
import Client from '../../../client'
import Errors from '../../../components/Errors'
import { pluralize } from '../../../utils/string'

interface Props {
  data: any
  verbiagePurge: boolean
  onDeleteComplete: (data) => void
  isOpen: boolean
  onClose: () => void
}

class DeleteDialog extends React.Component<Props> {
  state = {
    loading: false,
    error: null
  }

  deleteProducts = async () => {
    const { data, onDeleteComplete } = this.props
    if (data.all) {
      delete data.productIds
    }
    try {
      this.setState({ loading: true, error: null })
      const res = await Client.v4BulkProductDestroy(data)
      this.setState({ loading: false })
      onDeleteComplete(res.data)
    } catch (error) {
      this.setState({ loading: false, error: error.response.data })
    }
  }

  render = () => {
    const { loading, error } = this.state
    const { data } = this.props

    // true if this should display "purge" verbiage
    // false if this should display "delete" verbiage
    const { verbiagePurge } = this.props
    const verbString = verbiagePurge ? 'Purge' : 'Delete'

    let deleteMessage
    if (data.all) {
      deleteMessage = `${verbString} all selected products`
    } else if (data.productIds) {
      deleteMessage = `${verbString} ${data.productIds.length} product${pluralize(data.productIds)}`
    } else {
      // This should never happen, adding for safety
      deleteMessage = `${verbString} products`
    }

    return (
      <Dialog title={`${verbString} products`} {...this.props}>
        <DialogBody>
          <Errors error={error} />
          <H5>Are you sure you want to {deleteMessage.toLowerCase()}?</H5>
          <p>The product{pluralize(data.productIds)} will be permanently deleted and cannot be recovered.</p>
        </DialogBody>
        <DialogFooter
          actions={
            <Button loading={loading} disabled={loading} intent={Intent.DANGER} onClick={this.deleteProducts}>
              {deleteMessage}
            </Button>
          }
        />
      </Dialog>
    )
  }
}

export default DeleteDialog
